"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _Loader = _interopRequireDefault(require("@insided/shared/uikit/Loader"));

var hasChildren = function hasChildren(children) {
  if (!children) {
    return false;
  }

  return !(Array.isArray(children) && children.length === 0);
};

var SubtleButton = function SubtleButton(props) {
  var _ref;

  var _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$isSelected = props.isSelected,
      isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      className = props.className,
      onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      children = props.children,
      ariaLabel = props.ariaLabel,
      ariaExpanded = props.ariaExpanded,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      title = props.title,
      icon = props.icon,
      startIcon = props.startIcon,
      endIcon = props.endIcon,
      dataQa = props['data-qa']; // Icon-only button: has icon but no title/children

  var isIconOnly = ((_ref = icon !== null && icon !== void 0 ? icon : startIcon) !== null && _ref !== void 0 ? _ref : endIcon) && !title && !hasChildren(children);
  var buttonClasses = (0, _classnames.default)('subtle-button', "subtle-button--".concat(size), {
    'subtle-button--disabled': disabled,
    'subtle-button--selected': isSelected,
    'subtle-button--icon-only': isIconOnly,
    'subtle-button--icon': icon,
    'subtle-button--start-icon': startIcon,
    'subtle-button--end-icon': endIcon
  }, className);
  return (0, _preact.h)("button", {
    type: type,
    className: buttonClasses,
    onClick: onClick,
    onKeyDown: onKeyDown,
    disabled: disabled || isLoading,
    "aria-label": ariaLabel,
    "aria-expanded": ariaExpanded,
    title: typeof title === 'string' ? title : undefined,
    "data-qa": dataQa
  }, isLoading ? (0, _preact.h)("div", null, (0, _preact.h)(_Loader.default, null), (0, _preact.h)("span", {
    className: "subtle-button__label--hide"
  }, hasChildren(children) ? children : title)) : (0, _preact.h)("div", null, startIcon && (0, _preact.h)("span", {
    className: "subtle-button__icon-before"
  }, startIcon), icon && (0, _preact.h)("span", {
    className: "subtle-button__icon-before"
  }, icon), hasChildren(children) && children, !hasChildren(children) && title && (0, _preact.h)("span", {
    className: "subtle-button__label"
  }, title), endIcon && (0, _preact.h)("span", {
    className: "subtle-button__icon-after"
  }, endIcon)));
};

var _default = SubtleButton;
exports.default = _default;